var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.0625H1.5C1.1925 17.0625 0.9375 16.8075 0.9375 16.5C0.9375 16.1925 1.1925 15.9375 1.5 15.9375H16.5C16.8075 15.9375 17.0625 16.1925 17.0625 16.5C17.0625 16.8075 16.8075 17.0625 16.5 17.0625Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 17.0625H7.3125C7.005 17.0625 6.75 16.8075 6.75 16.5V3C6.75 1.71 7.4625 0.9375 8.6625 0.9375H9.3375C10.5375 0.9375 11.25 1.71 11.25 3V16.5C11.25 16.8075 10.995 17.0625 10.6875 17.0625ZM7.875 15.9375H10.125V3C10.125 2.1375 9.72 2.0625 9.3375 2.0625H8.6625C8.28 2.0625 7.875 2.1375 7.875 3V15.9375Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.0625H2.25C1.9425 17.0625 1.6875 16.8075 1.6875 16.5V7.5C1.6875 6.21 2.3475 5.4375 3.45 5.4375H4.05C5.1525 5.4375 5.8125 6.21 5.8125 7.5V16.5C5.8125 16.8075 5.5575 17.0625 5.25 17.0625ZM2.8125 15.9375H4.6875V7.5C4.6875 6.5625 4.275 6.5625 4.05 6.5625H3.45C3.225 6.5625 2.8125 6.5625 2.8125 7.5V15.9375Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.0625H12.75C12.4425 17.0625 12.1875 16.8075 12.1875 16.5V11.25C12.1875 9.96 12.8475 9.1875 13.95 9.1875H14.55C15.6525 9.1875 16.3125 9.96 16.3125 11.25V16.5C16.3125 16.8075 16.0575 17.0625 15.75 17.0625ZM13.3125 15.9375H15.1875V11.25C15.1875 10.3125 14.775 10.3125 14.55 10.3125H13.95C13.725 10.3125 13.3125 10.3125 13.3125 11.25V15.9375Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.75b723a440d4d5a4c4b7adc4fa78c3a9.svg";
export { ForwardRef as ReactComponent };